<template>
  <div class="contain">
    <div
      class="box-login"
      :style="{
        width: screenWidth + 'px',
      }"
    >
      <!--
      style="min-width: 1200px"
         :style="{
        width: screenWidth + 'px',
        height: $px2rem(`${screenHeight}px`),
      }" -->
      <!-- :style="{
    width: $px2rem(`${screenWidth}px`),
    height: $px2rem(`${screenHeight}px`),
  }" -->
      <div class="logo" style="top: 60px; left: 370px">
        <img
          src="@/assets/logo-2.png"
          class="logoImg"
          style="width: 234px; height: 61px"
          alt=""
        />
      </div>
      <div
        class="login-main"
        :style="{
          right: $px2rem(`${360}px`),
          top: $px2rem(`${279}px`),
        }"
      >
        <div class="cly-1">登录/注册</div>
        <div :class="{ 'cly-2': true, clyFocus: focusInp }">
          <div class="inp-front">+86</div>
          <input
            type="text"
            placeholder="请输入手机号码"
            class="inp-box1"
            v-model="phoneNum"
            @focus="focusInp = true"
            @blur="focusInp = false"
            maxlength="11"
          />
        </div>
        <div class="cly-3">
          <input
            type="text"
            placeholder="请输入手机验证码"
            class="inp-box2"
            v-model="sendCode"
            maxlength="4"
          />
          <div class="getBut" v-if="sended == true">
            {{ sendNum }}s后重新发送
          </div>
          <div class="sendBut" @click="sendInfo" v-else>发送验证码</div>
        </div>
        <div class="cly-4">
          <div
            class="loginBut"
            :style="{
              color: checkAll ? '#fff' : '#8A8A8A',
              background: checkAll ? '#45796E' : '#F4F5F7',
            }"
            @click.stop="toLogin"
          >
            立即登录
          </div>
        </div>
        <div class="cly-5">
          <div
            :class="[checked ? 'check-inped' : 'check-inp']"
            @click="checked = !checked"
          >
            <div class="tipsBox" v-if="!checked">
              <img src="@/assets/tips-bg.png" class="tipsIcon" alt="" />
              <div class="tipsText">请勾选同意后再登录</div>
            </div>
            <transition name="el-fade-in">
              <img
                v-show="checked"
                src="@/assets/check-icon-w.png"
                class="check-icon"
                alt=""
              />
            </transition>
          </div>
          <div class="text">
            我已阅读并同意
            <a href="https://zaixianjisi.com/zxjsUser.html" target="_blank"
              >《用户服务协议》</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  smsCode,
  validate,
  loginSms,
  getMyBaseInfo,
  bindCode,
} from "@/api/request";
export default {
  components: {},
  data() {
    return {
      phoneNum: "",
      sendCode: "",
      checked: false,
      focusInp: false,
      sended: false,
      sendNum: 30,
      redicUrl: "",
      screenWidth: 0,
      screenHeight: 0,
    };
  },
  created() {
    this.$parent.ifshowmainTopBg = false;
    if (this.$route.query.redirect) {
      this.redicUrl = this.$route.query.redirect;
    }
    this.screenWidth = 0;
    this.screenHeight = 0;
    let data = this.getViewportSize();
    this.screenWidth = data.pageWidth;
    if (this.screenWidth < 1200) {
      this.screenWidth = 1200;
    }
    this.screenHeight = data.pageHeight;
  },
  computed: {
    checkAll() {
      if (
        this.checked == true &&
        this.phoneNum.length == 11 &&
        this.sendCode.length == 4
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
  mounted() {
    window.addEventListener("resize", (res) => {
      let data = this.getViewportSize();
      this.screenWidth = data.pageWidth;
      this.screenHeight = data.pageHeight;
    });
  },
  methods: {
    getViewportSize() {
      var pageWidth = window.innerWidth,
        pageHeight = window.innerHeight;
      // 判断浏览器是否支持innerWidth
      if (typeof pageWidth !== "number") {
        // 文档渲染模式是标准模式
        if (document.compatMode == "CSS1Compat") {
          pageWidth = document.documentElement.clientWidth;
          pageHeight = document.documentElement.clientHeight;
        } else {
          // 文档渲染模式是混杂模式或怪异模式
          pageWidth = document.body.clientWidth;
          pageHeight = document.body.clientHeight;
        }
      }
      return {
        pageWidth,
        pageHeight,
      };
    },
    sendInfo() {
      if (this.phoneNum.length < 11) {
        return this.$message.error("请输入正确的手机号");
      }
      this.sended = true;
      this.sendCodes();
      let timer = null;
      if (!timer) {
        timer = setInterval(() => {
          if (this.sendNum > 0) {
            this.sendNum -= 1;
          } else {
            clearInterval(timer);
            timer = null;
            this.sendNum = 30;
            this.sended = false;
          }
        }, 1000);
      }
    },
    sendCodes() {
      let data = {
        phone: this.phoneNum,
        areaCode: 86,
      };
      smsCode(data).then((res) => {});
    },
    toLogin() {
      if (!this.checkAll) {
        return;
      }
      validate({
        phone: this.phoneNum,
        smsCode: this.sendCode,
        smsType: 1,
        verifyType: 2,
      }).then((res) => {
        if (res.data.code == 200) {
          loginSms({ phone: this.phoneNum, smsCode: this.sendCode }).then(
            (res) => {
              getMyBaseInfo().then((res) => {
                this.$store.commit("SET_USER", res.data.result);
              });
              this.$store.commit("SET_TOKEN", res.data.result.access_token);
              if (localStorage.getItem("inviteCode")) {
                bindCode({
                  inviteCode: localStorage.getItem("inviteCode"),
                }).then((res) => {
                  localStorage.removeItem("inviteCode");
                });
              }
              if (!this.redicUrl) {
                this.$router.replace("/");
              } else {
                this.$router.replace(this.redicUrl);
              }
              this.$parent.ifshowmainTopBg = true;
            }
          );
        } else {
          return this.$message.error("校验失败!");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./login.scss";
:deep .el-input__inner {
  border-radius: 10px;
}
.contain {
  width: 100vw;
  height: 100vh;
  position: relative;
}
.box-login {
  position: absolute;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  //background-color: #b8e5f8;
  background-image: url(https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo/login-bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
  width: 100%;
  .login-main {
    width: 398px;
    height: 450px;
    background: #fff;
    border-radius: 10px;
    filter: drop-shadow(2px 4px 6px #203b3040);
    position: absolute;
    //top: 279px;
    //right: 360px;
    padding: 38px 32px;
    box-sizing: border-box;
  }
}
</style>
